import { render, staticRenderFns } from "./publicity.vue?vue&type=template&id=251d295c&scoped=true&"
import script from "./publicity.vue?vue&type=script&lang=js&"
export * from "./publicity.vue?vue&type=script&lang=js&"
import style0 from "./publicity.vue?vue&type=style&index=0&id=251d295c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251d295c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
